import ReturnTranslatedText from './lib/ReturnTranslatedText';

export { ReturnTranslatedText };
